function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import Select from '@material-ui/core/Select';
import Chip from '@material-ui/core/Chip';
import InputAdornment from '@material-ui/core/InputAdornment';
import Icon from '@material-ui/core/Icon';
const useStyles = makeStyles(theme => ({
  root: {
    //        height: theme.spacing(7),
    "& .MuiFormLabel-root": {
      fontFamily: "Akkurat, sans-serif"
    },
    "& .MuiInputBase-root": {
      fontFamily: "Akkurat, sans-serif",
      borderTopLeftRadius: "0",
      borderTopRightRadius: "0"
    },
    "& .MuiFormHelperText-root": {
      fontFamily: "Akkurat, sans-serif"
    }
  },
  select: {
    position: "relative",
    display: "flex"
  },
  startAdornment: {
    position: "absolute",
    left: 0,
    top: 0,
    right: "auto",
    bottom: 0,
    "& + *": {
      paddingLeft: theme.spacing(7)
    }
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  chip: {
    margin: 2
  }
}));

const SelectedChips = ({
  selected
}) => {
  const classes = useStyles();
  return React.createElement("div", {
    className: classes.chips
  }, selected && selected.length && selected.map((option, index) => React.createElement(Chip, {
    key: index,
    label: option.label,
    className: classes.chip
  })));
};

const SelectField = (_ref) => {
  let id = _ref.id,
      icon = _ref.icon,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "Select" : _ref$label,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? undefined : _ref$value,
      placeholder = _ref.placeholder,
      helperText = _ref.helperText,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? false : _ref$multiple,
      onChange = _ref.onChange,
      props = _objectWithoutPropertiesLoose(_ref, ["id", "icon", "label", "value", "placeholder", "helperText", "options", "multiple", "onChange"]);

  const classes = useStyles();
  const labelId = id + "-label";

  const shrinkLabel = () => {
    return placeholder && true || value && true || false;
  };

  const displayEmpty = () => {
    return value && true || placeholder && true || false;
  };

  const renderValue = value => {
    const selected = options.filter(o => o.value === value);
    return selected && selected[0] && selected[0].label || value || placeholder;
  };

  const renderSelected = value => {
    const selected = options.filter(o => value.includes(o.value));
    return React.createElement(SelectedChips, {
      selected: selected
    });
  };

  let iconPrefix;

  if (icon) {
    iconPrefix = React.createElement(Icon, {
      className: classes.iconPrefix
    }, icon);
  }

  let startAdornment, endAdornment;

  if (iconPrefix) {
    startAdornment = React.createElement("div", {
      className: classes.startAdornment,
      position: "start"
    }, iconPrefix);
  }

  return React.createElement(FormControl, {
    className: classes.root,
    variant: "filled",
    fullWidth: true
  }, React.createElement(InputLabel, {
    className: iconPrefix && classes.iconPrefixLabel,
    shrink: shrinkLabel,
    id: labelId
  }, label), React.createElement("div", {
    className: classes.select
  }, startAdornment, React.createElement(Select, {
    fullWidth: true,
    displayEmpty: displayEmpty,
    label: label,
    id: id,
    value: value,
    renderValue: renderValue,
    displayEmpty: placeholder && true,
    onChange: onChange
  }, options.map((option, index) => {
    return React.createElement(MenuItem, _extends({
      value: option.value
    }, option, {
      key: index
    }), option.label);
  }))), helperText && React.createElement(FormHelperText, null, helperText));
};

export default SelectField;